import { useState, useEffect } from 'react';
import { api } from '../api';

export default function Inventario() {
  const [marcas, setMarcas] = useState([]);
  const [marcaSeleccionada, setMarcaSeleccionada] = useState('');
  const [busqueda, setBusqueda] = useState('');
  const [top25, setTop25] = useState(null);
  const [dataMarca, setDataMarca] = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    cargarInicial();
  }, []);

  const cargarInicial = async () => {
    setCargando(true);
    try {
      const [marcasData, topData] = await Promise.all([
        api.get('/inventario/marcas'),
        api.get('/inventario/top')
      ]);
      setMarcas(marcasData.marcas || []);
      setTop25(topData.productos || []);
    } catch (e) {
      console.error(e);
    } finally {
      setCargando(false);
    }
  };

  const seleccionarMarca = async (marca) => {
    setMarcaSeleccionada(marca);
    setCargando(true);
    try {
      const data = await api.get(`/inventario/marca?marca=${encodeURIComponent(marca)}`);
      setDataMarca(data);
    } catch (e) {
      console.error(e);
    } finally {
      setCargando(false);
    }
  };

  const limpiar = () => {
    setMarcaSeleccionada('');
    setDataMarca(null);
    setBusqueda('');
  };

  const marcasFiltradas = marcas.filter(m =>
    m.toLowerCase().includes(busqueda.toLowerCase())
  );

  return (
    <div style={s.container}>
      {/* Sidebar marcas */}
      <div style={s.sidebar}>
        <div style={s.sidebarHeader}>
          <div style={s.sidebarTitulo}>🏷️ Marcas</div>
          <span style={s.marcasCount}>{marcas.length}</span>
        </div>
        <input
          style={s.searchInput}
          value={busqueda}
          onChange={e => setBusqueda(e.target.value)}
          placeholder="Buscar marca..."
        />
        <div style={s.marcasList}>
          <div
            style={{...s.marcaItem, ...(marcaSeleccionada === '' ? s.marcaItemActivo : {})}}
            onClick={limpiar}
          >
            📦 Top 25 Stock
          </div>
          {marcasFiltradas.map(m => (
            <div
              key={m}
              style={{...s.marcaItem, ...(marcaSeleccionada === m ? s.marcaItemActivo : {})}}
              onClick={() => seleccionarMarca(m)}
            >
              {m}
            </div>
          ))}
        </div>
      </div>

      {/* Contenido principal */}
      <div style={s.main}>
        {cargando ? (
          <p style={s.cargando}>Cargando...</p>
        ) : marcaSeleccionada === '' ? (
          /* Vista Top 25 */
          <>
            <h2 style={s.titulo}>📦 Top 25 — Mayor Stock</h2>
            <p style={s.subtitulo}>Productos con mayor cantidad de unidades en bodega · identifica exceso de mercadería</p>
            <TablaProductos productos={top25} showMarca={true} />
          </>
        ) : (
          /* Vista por marca */
          <>
            <div style={s.marcaHeader}>
              <div>
                <h2 style={s.titulo}>🏷️ {marcaSeleccionada}</h2>
                <p style={s.subtitulo}>Inventario completo en BOD. ESTACION</p>
              </div>
              <button style={s.botonLimpiar} onClick={limpiar}>← Volver</button>
            </div>

            {dataMarca && (
              <>
                {/* KPIs resumen */}
                <div style={s.kpisRow}>
                  <div style={s.kpiCard}>
                    <div style={s.kpiValor}>{dataMarca.resumen.total_productos}</div>
                    <div style={s.kpiLabel}>Productos</div>
                  </div>
                  <div style={{...s.kpiCard, borderTopColor: '#4cc9f0'}}>
                    <div style={s.kpiValor}>{dataMarca.resumen.stock_total.toFixed(0)}</div>
                    <div style={s.kpiLabel}>Unidades en stock</div>
                  </div>
                  <div style={{...s.kpiCard, borderTopColor: '#f72585'}}>
                    <div style={s.kpiValor}>${dataMarca.resumen.valor_inventario.toFixed(2)}</div>
                    <div style={s.kpiLabel}>Valor inventario</div>
                  </div>
                </div>

                <TablaProductos productos={dataMarca.productos} showMarca={false} />
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}

function TablaProductos({ productos, showMarca }) {
  if (!productos || productos.length === 0) return (
    <p style={{ color: '#555', textAlign: 'center', marginTop: 40 }}>Sin productos</p>
  );

  const maxStock = productos[0]?.stock || 1;

  return (
    <div style={s.tabla}>
      <div style={s.tablaHeader}>
        <span style={{ flex: 1 }}>CÓDIGO</span>
        <span style={{ flex: 4 }}>DESCRIPCIÓN</span>
        {showMarca && <span style={{ flex: 1 }}>MARCA</span>}
        <span style={{ width: 120, textAlign: 'right' }}>STOCK</span>
        <span style={{ width: 100, textAlign: 'right' }}>COSTO</span>
        <span style={{ width: 110, textAlign: 'right' }}>VALOR</span>
      </div>
      {productos.map((p, i) => (
        <div key={i} style={{...s.tablaRow, background: i % 2 === 0 ? '#1e1e2e' : '#1a1a2e'}}>
          <span style={{ flex: 1, color: '#555', fontSize: 11 }}>{p.codigo}</span>
          <span style={{ flex: 4, color: '#fff', fontSize: 13 }}>{p.item}</span>
          {showMarca && <span style={{ flex: 1, color: '#4cc9f0', fontSize: 12 }}>{p.marca}</span>}
          <div style={{ width: 120, textAlign: 'right' }}>
            <div style={s.barraContainer}>
              <div style={{ ...s.barraFill, width: `${(p.stock / maxStock) * 100}%` }} />
            </div>
            <span style={{ color: '#fff', fontWeight: 'bold', fontSize: 13 }}>{p.stock.toFixed(0)}</span>
          </div>
          <span style={{ width: 100, textAlign: 'right', color: '#aaa', fontSize: 13 }}>${p.costo.toFixed(2)}</span>
          <span style={{ width: 110, textAlign: 'right', color: '#4cc9f0', fontSize: 13 }}>${p.valor.toFixed(2)}</span>
        </div>
      ))}
    </div>
  );
}

const s = {
  container: { display: 'flex', gap: 0, minHeight: 'calc(100vh - 64px)', margin: '-32px' },
  sidebar: { width: 220, background: '#1a1a2e', borderRight: '1px solid #2d2d44', display: 'flex', flexDirection: 'column', padding: 16, height: 'calc(100vh - 64px)', overflowY: 'hidden', position: 'sticky', top: 0 },
  sidebarHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 },
  sidebarTitulo: { color: '#fff', fontWeight: 'bold', fontSize: 14 },
  marcasCount: { background: '#2d2d44', color: '#aaa', borderRadius: 10, padding: '2px 8px', fontSize: 11 },
  searchInput: { background: '#0f0f1a', border: '1px solid #2d2d44', borderRadius: 6, color: '#fff', padding: '8px 10px', fontSize: 12, marginBottom: 8, width: '100%' },
  marcasList: { flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 2 , maxHeight: 'calc(100vh - 180px)' },
  marcaItem: { padding: '8px 10px', borderRadius: 6, cursor: 'pointer', color: '#888', fontSize: 12, transition: 'background 0.2s' },
  marcaItemActivo: { background: '#2d2d44', color: '#fff' },
  main: { flex: 1, padding: 32, overflowY: 'auto' },
  titulo: { color: '#fff', marginBottom: 4 },
  subtitulo: { color: '#555', fontSize: 13, marginBottom: 24 },
  marcaHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 },
  botonLimpiar: { background: 'none', border: '1px solid #444', borderRadius: 8, color: '#aaa', padding: '8px 16px', cursor: 'pointer' },
  kpisRow: { display: 'flex', gap: 16, marginBottom: 24 },
  kpiCard: { background: '#1e1e2e', borderRadius: 12, padding: 20, flex: 1, borderTop: '3px solid #7209b7' },
  kpiValor: { color: '#fff', fontSize: 28, fontWeight: 'bold', marginBottom: 4 },
  kpiLabel: { color: '#aaa', fontSize: 12 },
  cargando: { color: '#aaa', padding: 40, textAlign: 'center' },
  tabla: { borderRadius: 12, overflow: 'hidden' },
  tablaHeader: { display: 'flex', padding: '10px 16px', background: '#0f0f1a', color: '#555', fontSize: 11, fontWeight: 'bold', gap: 8 },
  tablaRow: { display: 'flex', padding: '10px 16px', gap: 8, alignItems: 'center' },
  barraContainer: { background: '#2a2a3e', borderRadius: 3, height: 4, marginBottom: 3 },
  barraFill: { height: 4, borderRadius: 3, background: '#7209b7' },
};